import React from 'react';
import { connect } from 'react-redux';
import {
    fetchEBizChargeWebFormUrl,
    handleEBizChargePayment
} from './paymentMethodActionCreators';
import { mapStateToPlaceOrderDetails } from '../PlaceOrder';
import { Fade } from '../../componentAnimations';

class EBizChargePaymentComponent extends React.Component {

    componentDidUpdate() {
        this.fetchEBizChargeWebFormUrlIfNeeded();
    }

    componentDidMount() {
        this.handleMessage = this.handleMessage.bind(this);
        window.addEventListener('message', this.handleMessage);
        this.fetchEBizChargeWebFormUrlIfNeeded();
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    fetchEBizChargeWebFormUrlIfNeeded() {
        // if selected but not already fetching/fetched => dispatch eBizChargePaymentWebUrl
        if(this.props.isSelected && // on payment screen
            !!!this.props.eBizChargePaymentWebFormError && // no error
            !!!this.props.fetchingEBizChargePaymentWebFormUrl && // not fetching
            (!this.props.eBizChargePaymentWebFormUrl || this.props.eBizChargePaymentWebFormUrl === "")) {
            this.props.fetchEBizChargeWebFormUrl(this.props.placeOrderDetails);
        }
    }

    handleMessage(event) {
        // Only react to messages from same domain as current document
        if (event.origin !== this.props.allowedOrigin || !event.data || !event.data.MessageType ||
            event.data.MessageType !== "EBizChargePaymentResult")
            return;

        try {
            this.props.handleEBizChargePayment(event.data);
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const {
            isSelected,
            eBizChargePaymentWebFormUrl,
        } = this.props;
        const show = isSelected && eBizChargePaymentWebFormUrl && eBizChargePaymentWebFormUrl !== "";
        return <Fade inProp={show}>
            <iframe
                scrolling="no"
                src={eBizChargePaymentWebFormUrl}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block',
                    overflow: 'hidden',
                    minHeight: '110rem'
                }}
            />
        </Fade>
    }
}


const mapEBizChargePaymentComponentStateToProps = (state, ownProps) => {
    return {
        eBizChargePaymentWebFormUrl: state.entities.EBizChargePaymentWebFormUrl,
        placeOrderDetails: mapStateToPlaceOrderDetails(state),
        fetchingEBizChargePaymentWebFormUrl: state.entities.FetchingEBizChargePaymentWebFormUrl,
        eBizChargePaymentWebFormError: state.entities.EBizChargePaymentWebFormError,
        allowedOrigin: state.constants.allowedOrigin,
        ...ownProps
    }
}

const mapEBizChargePaymentComponentDispatchToProps = (dispatch) => {
    return {
        fetchEBizChargeWebFormUrl: (placeOrderDetails) => dispatch(fetchEBizChargeWebFormUrl(placeOrderDetails)),
        handleEBizChargePayment: (payload) => dispatch(handleEBizChargePayment(payload)),
    }
}

const EBizChargePaymentComponentContainer = connect(
    mapEBizChargePaymentComponentStateToProps,
    mapEBizChargePaymentComponentDispatchToProps
)(EBizChargePaymentComponent);


export default EBizChargePaymentComponentContainer
